export const donutChartColor = "#00722A";
export const barChartColor = "#5564FF";
export const pieChartColor = "#F27818";
export const tableChartColor = "#00722A"; // not using this color
export const horizontalBarChartColor = "#5564FF"; // not using this color
